import appInvoices from "../../views/appPlans/invoiceItems.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "invoiceitems";
  const params = [
    "page",
    "limit",
    "cash_collection_status",
    "city",
    "active",
    "date",
    "captain",
  ];
  $stateProvider.state("invoiceitems", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appInvoices,
      },
    },
    reloadOnSearch: false,
    data: { title: "Invoice Items" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/invoiceItems/invoiceItems.urls.js